import styled from "styled-components";

export const GeneralReportWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& select": {
      padding: "0.7rem 0.8rem",
      borderRadius: "0.45rem",
      border: "1px solid #d9dee7",
      fontWeight: "400",
      color: "var(--color-text)",
      backgroundColor: "var(--color-neutral)",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& .filters-card": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.85rem",
      backgroundColor: "var(--color-primary-hover)",
      padding: "1rem",
      display: "grid",
      gap: "1rem",
    },
    "& .filter-title": {
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "0.45rem",
      fontFamily: "Poppins",
      color: "var(--color-text-light)",
      fontSize: "0.78rem",
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    "& .filter": {
      display: "grid",
      gap: "0.9rem",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      alignItems: "end",
      margin: 0,
    },
    "& .filters-action-slot": {
      width: "100%",
      display: "flex",
      alignItems: "end",
      justifyContent: "stretch",
      minWidth: 0,
      overflow: "hidden",
      "& > div": {
        width: "100%",
      },
      "& button": {
        width: "100%",
        border: "none",
        borderRadius: ".45rem",
        transition: "background-color 0.2s ease",
        height: "3rem",
        "&:hover": {
          backgroundColor: "#1f5620",
        },
      },
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "var(--color-primary)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      marginBottom: "0.45rem",
      display: "inline-block",
    },
    "& .report-table-card": {
      border: "1px solid #e5e7eb",
      borderRadius: "0.9rem",
      overflow: "hidden",
      backgroundColor: "var(--color-neutral)",
    },
    "& .general-report-table": {
      overflowX: "auto",
    },
    "& .report-table-card table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "1100px",
    },
    "& .report-table-card th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "180px",
      fontWeight: 700,
      textAlign: "left",
      whiteSpace: "nowrap",
    },
    "& .report-table-card td": {
      border: "none",
      borderBottom: "1px solid #edf1f6",
      color: "var(--color-text)",
      padding: "0.95rem 1rem",
      minWidth: "180px",
      fontSize: "0.88rem",
      verticalAlign: "middle",
      whiteSpace: "nowrap",
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      borderRadius: "0.9rem",
      padding: "calc(var(--cardPadding) * 1)",
        
      boxShadow: "0px 20px 24px -4px #10182814",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "0.9rem",
        width: "85%",
      },
    },
    "& .error-box": {
      padding: "0",
      "& p": {
        margin: "0.2rem 0 0",
        color: "#B91C1C",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "0.88rem",
      },
    },
    "& .export-button-area": {
      padding: "1rem",
      borderBottom: "1px solid #edf1f6",
      display: "flex",
      justifyContent: "flex-end",
      backgroundColor: "var(--color-neutral)",
    },
    "@media screen and (max-width: 1280px)": {
      "& .filter": {
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      },
    },
    "@media screen and (max-width: 768px)": {
      "& .filter": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      "& .filters-action-slot": {
        width: "100%",
      },
    },
    "@media screen and (max-width: 640px)": {
      "& .filters-card": {
        padding: "0.75rem",
      },
      "& .filter": {
        gridTemplateColumns: "1fr",
      },
    },
  };
});
